var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7077 38.8333V35.6666C32.7077 33.9869 32.058 32.376 30.9015 31.1882C29.745 30.0005 28.1765 29.3333 26.541 29.3333H14.2077C12.5722 29.3333 11.0037 30.0005 9.84719 31.1882C8.69072 32.376 8.04102 33.9869 8.04102 35.6666V38.8333",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3757 22.9999C23.7814 22.9999 26.5423 20.1644 26.5423 16.6666C26.5423 13.1688 23.7814 10.3333 20.3757 10.3333C16.9699 10.3333 14.209 13.1688 14.209 16.6666C14.209 20.1644 16.9699 22.9999 20.3757 22.9999Z",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.959 38.8332V35.6666C41.958 34.2633 41.5032 32.9001 40.6661 31.7911C39.829 30.682 38.6569 29.8899 37.334 29.5391",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.166 10.5391C32.4925 10.8879 33.6682 11.6802 34.5078 12.7911C35.3474 13.9019 35.8031 15.2682 35.8031 16.6745C35.8031 18.0807 35.3474 19.447 34.5078 20.5579C33.6682 21.6688 32.4925 22.4611 31.166 22.8099",
    stroke: "#02B4BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "white",
    transform: "translate(6.5 5.58325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.4f8dd9757e5f42c0552532084facf62d.svg";
export { ForwardRef as ReactComponent };